const USER = {
    LOAD: 'USER_LOAD',
    LOAD_SUCCESS: 'USER_LOAD_SUCCESS',
    LOAD_FAIL: 'USER_LOAD_FAIL'
}

const POST = {
    LOAD: 'POST_LOAD',
    LOAD_SUCCESS: 'POST_LOAD_SUCCESS',
    LOAD_FAIL: 'POST_LOAD_FAIL'
}

const SPOST = {
    LOAD: 'SPOST_LOAD',
    LOAD_SUCCESS: 'SPOST_LOAD_SUCCESS',
    LOAD_FAIL: 'SPOST_LOAD_FAIL'
}

const USERTASK = {
    LOAD: 'USERTASK_LOAD',
    LOAD_SUCCESS: 'USERTASK_LOAD_SUCCESS',
    LOAD_FAIL: 'USERTASK_LOAD_FAIL'
}

const POSTTASK = {
    LOAD: 'POSTTASK_LOAD',
    LOAD_SUCCESS: 'POSTTASK_LOAD_SUCCESS',
    LOAD_FAIL: 'POSTTASK_LOAD_FAIL'
}

export { USER, POST, USERTASK, POSTTASK, SPOST };